<div class="landing-a">
  <app-landing-1-navbar [dashboardUrl]="treesloDashboardUrl" />

  <app-landing-1-hero
    [dashboardUrl]="treesloDashboardUrl"
    (scrollTopVisibleChange)="onHeroScrollTopVisibleChange($event)"
  />

  <app-landing-1-our-product />

  <app-landing-1-onboarding />

  <app-landing-1-recovery-statement />

  <app-landing-1-features />

  <app-landing-1-how-it-works />

  <app-landing-1-why />

  <app-landing-1-compare />

  <app-landing-1-pricing [dashboardUrl]="treesloDashboardUrl" />

  <app-landing-1-cta [dashboardUrl]="treesloDashboardUrl" />

  <app-landing-1-footer />

  <app-landing-1-scroll-top
    [visible]="showScrollTop()"
    (scrollTop)="scrollToTop()"
  />
</div>
